const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        appearances: {},
        variantGroups: {
            status: {
                secondary: {
                    default: false,
                },
                subtle: {
                    default: false,
                },
                tertiary: {
                    default: false,
                },
                transparent: {
                    default: false,
                },
            },
            size: {
                sm: {
                    default: false,
                },
                md: {
                    default: true,
                },
                lg: {
                    default: false,
                },
                xl: {
                    default: false,
                },
            },
        },
        parameters: {
            borderColorDark: {
                type: 'string',
            },
            textColorDark: {
                type: 'string',
            },
            iconTintColorDark: {
                type: 'string',
            },
            backgroundColorDark: {
                type: 'string',
            },
            height: {
                type: 'number',
            },
            iconMargin: {
                type: 'number',
            },
        },
    },
    appearances: {
        filled: {
            mapping: {
                textFontFamily: 'text-font-family',
                textColor: '$color-white',
                textColorDark: '$color-white',
                iconTintColor: '$color-white',
                iconTintColorDark: '$color-white',
            },
            variantGroups: {
                status: {
                    primary: {
                        borderColor: '$color-ui2-brand-600',
                        borderColorDark: '$color-ui2-brand-500',
                        backgroundColor: '$color-ui2-brand-600',
                        backgroundColorDark: '$color-ui2-brand-500',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-brand-700',
                                borderColorDark: '$color-ui2-brand-600',
                                backgroundColor: '$color-ui2-brand-700',
                                backgroundColorDark: '$color-ui2-brand-600',
                            },
                            active: {
                                borderColor: '$color-ui2-brand-800',
                                borderColorDark: '$color-ui2-brand-700',
                                backgroundColor: '$color-ui2-brand-800',
                                backgroundColorDark: '$color-ui2-brand-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-brand-800',
                                borderColorDark: '$color-ui2-brand-700',
                                backgroundColor: '$color-ui2-brand-800',
                                backgroundColorDark: '$color-ui2-brand-700',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-400',
                                textColorDark: '$color-ui2-neutral-500',
                                iconTintColor: '$color-ui2-neutral-400',
                                iconTintColorDark: '$color-ui2-neutral-500',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-ui2-neutral-700',
                            },
                        },
                    },
                    secondary: {
                        borderColor: '$color-ui2-neutral-100',
                        borderColorDark: '$color-ui2-neutral-700',
                        textColor: '$color-ui2-neutral-900',
                        textColorDark: '$color-white',
                        iconTintColor: '$color-ui2-neutral-900',
                        iconTintColorDark: '$color-white',
                        backgroundColor: '$color-ui2-neutral-100',
                        backgroundColorDark: '$color-ui2-neutral-700',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: '$color-ui2-neutral-600',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-ui2-neutral-600',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-500',
                                backgroundColor: '$color-ui2-neutral-300',
                                backgroundColorDark: '$color-ui2-neutral-500',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-500',
                                backgroundColor: '$color-ui2-neutral-300',
                                backgroundColorDark: '$color-ui2-neutral-500',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-400',
                                textColorDark: '$color-ui2-neutral-500',
                                iconTintColor: '$color-ui2-neutral-400',
                                iconTintColorDark: '$color-ui2-neutral-500',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-ui2-neutral-700',
                            },
                        },
                    },
                    subtle: {
                        borderColor: '$color-ui2-neutral-50',
                        borderColorDark: '$color-white',
                        textColor: '$color-ui2-neutral-400',
                        textColorDark: '$color-ui2-neutral-800',
                        iconTintColor: '$color-ui2-neutral-400',
                        iconTintColorDark: '$color-ui2-neutral-800',
                        backgroundColor: '$color-ui2-neutral-50',
                        backgroundColorDark: '$color-white',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: '$color-white-transparent-80',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-white-transparent-80',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: '$color-white',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-white',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: '$color-white',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-white',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-50',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-500',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-500',
                                backgroundColor: '$color-ui2-neutral-50',
                                backgroundColorDark: '$color-ui2-neutral-700',
                            },
                        },
                    },
                    success: {
                        borderColor: '$color-ui2-success-500',
                        borderColorDark: '$color-ui2-success-500',
                        backgroundColor: '$color-ui2-success-500',
                        backgroundColorDark: '$color-ui2-success-500',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-success-600',
                                borderColorDark: '$color-ui2-success-600',
                                backgroundColor: '$color-ui2-success-600',
                                backgroundColorDark: '$color-ui2-success-600',
                            },
                            active: {
                                borderColor: '$color-ui2-success-700',
                                borderColorDark: '$color-ui2-success-700',
                                backgroundColor: '$color-ui2-success-700',
                                backgroundColorDark: '$color-ui2-success-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-success-700',
                                borderColorDark: '$color-ui2-success-700',
                                backgroundColor: '$color-ui2-success-700',
                                backgroundColorDark: '$color-ui2-success-700',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-400',
                                textColorDark: '$color-ui2-neutral-500',
                                iconTintColor: '$color-ui2-neutral-400',
                                iconTintColorDark: '$color-ui2-neutral-500',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-ui2-neutral-700',
                            },
                        },
                    },
                    warning: {
                        borderColor: '$color-ui2-warning-500',
                        borderColorDark: '$color-ui2-warning-500',
                        backgroundColor: '$color-ui2-warning-500',
                        backgroundColorDark: '$color-ui2-warning-500',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-warning-600',
                                borderColorDark: '$color-ui2-warning-600',
                                backgroundColor: '$color-ui2-warning-600',
                                backgroundColorDark: '$color-ui2-warning-600',
                            },
                            active: {
                                borderColor: '$color-ui2-warning-700',
                                borderColorDark: '$color-ui2-warning-700',
                                backgroundColor: '$color-ui2-warning-700',
                                backgroundColorDark: '$color-ui2-warning-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-warning-700',
                                borderColorDark: '$color-ui2-warning-700',
                                backgroundColor: '$color-ui2-warning-700',
                                backgroundColorDark: '$color-ui2-warning-700',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-400',
                                textColorDark: '$color-ui2-neutral-500',
                                iconTintColor: '$color-ui2-neutral-400',
                                iconTintColorDark: '$color-ui2-neutral-500',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-ui2-neutral-700',
                            },
                        },
                    },
                    danger: {
                        borderColor: '$color-ui2-danger-500',
                        borderColorDark: '$color-ui2-danger-500',
                        backgroundColor: '$color-ui2-danger-500',
                        backgroundColorDark: '$color-ui2-danger-500',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-danger-600',
                                borderColorDark: '$color-ui2-danger-600',
                                backgroundColor: '$color-ui2-danger-600',
                                backgroundColorDark: '$color-ui2-danger-600',
                            },
                            active: {
                                borderColor: '$color-ui2-danger-700',
                                borderColorDark: '$color-ui2-danger-700',
                                backgroundColor: '$color-ui2-danger-700',
                                backgroundColorDark: '$color-ui2-danger-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-danger-700',
                                borderColorDark: '$color-ui2-danger-700',
                                backgroundColor: '$color-ui2-danger-700',
                                backgroundColorDark: '$color-ui2-danger-700',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-400',
                                textColorDark: '$color-ui2-neutral-500',
                                iconTintColor: '$color-ui2-neutral-400',
                                iconTintColorDark: '$color-ui2-neutral-500',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-ui2-neutral-700',
                            },
                        },
                    },
                    transparent: {
                        borderColor: '$color-white-transparent-24',
                        borderColorDark: '$color-white-transparent-24',
                        textColor: '$color-white',
                        textColorDark: '$color-white',
                        iconTintColor: '$color-white',
                        iconTintColorDark: '$color-white',
                        backgroundColor: '$color-ui2-neutral-transparent-64',
                        backgroundColorDark: '$color-ui2-neutral-transparent-64',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-transparent-80',
                                borderColorDark: '$color-ui2-neutral-transparent-80',
                                backgroundColor: '$color-ui2-neutral-transparent-80',
                                backgroundColorDark: '$color-ui2-neutral-transparent-80',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-transparent-88',
                                borderColorDark: '$color-ui2-neutral-transparent-88',
                                backgroundColor: '$color-ui2-neutral-transparent-88',
                                backgroundColorDark: '$color-ui2-neutral-transparent-88',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-transparent-88',
                                borderColorDark: '$color-ui2-neutral-transparent-88',
                                backgroundColor: '$color-ui2-neutral-transparent-88',
                                backgroundColorDark: '$color-ui2-neutral-transparent-88',
                            },
                            disabled: {
                                borderColor: '$color-white-transparent-24',
                                borderColorDark: '$color-white-transparent-24',
                                backgroundColor: '$color-ui2-neutral-transparent-24',
                                backgroundColorDark: '$color-ui2-neutral-transparent-24',
                            },
                        },
                    },
                    tertiary: {
                        borderColor: '$color-gray-50',
                        borderColorDark: '$color-gray-50',
                        textColor: '$color-text-primary',
                        textColorDark: '$color-text-primary',
                        iconTintColor: '$color-text-primary',
                        iconTintColorDark: '$color-text-primary',
                        backgroundColor: '$color-gray-50',
                        backgroundColorDark: '$color-gray-50',
                        state: {
                            hover: {
                                borderColor: '$color-gray-100',
                                borderColorDark: '$color-gray-100',
                                textColor: '$color-text-primary',
                                textColorDark: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                iconTintColorDark: '$color-text-primary',
                                backgroundColor: '$color-gray-100',
                                backgroundColorDark: '$color-gray-100',
                            },
                            active: {
                                borderColor: '$color-gray-300',
                                borderColorDark: '$color-gray-300',
                                textColor: '$color-text-primary',
                                textColorDark: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                iconTintColorDark: '$color-text-primary',
                                backgroundColor: '$color-gray-300',
                                backgroundColorDark: '$color-gray-300',
                            },
                            focus: {
                                borderColor: '$color-gray-300',
                                borderColorDark: '$color-gray-300',
                                textColor: '$color-text-primary',
                                textColorDark: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                iconTintColorDark: '$color-text-primary',
                                backgroundColor: '$color-gray-300',
                                backgroundColorDark: '$color-gray-300',
                            },
                            disabled: {
                                borderColor: '$color-gray-50',
                                borderColorDark: '$color-gray-50',
                                textColor: '$color-text-extra-subtle',
                                textColorDark: '$color-text-extra-subtle',
                                iconTintColor: '$color-text-extra-subtle',
                                iconTintColorDark: '$color-text-extra-subtle',
                                backgroundColor: '$color-gray-50',
                                backgroundColorDark: '$color-gray-50',
                            },
                        },
                    },
                },
                size: {
                    sm: {
                        minWidth: 24,
                        minHeight: 24,
                        borderWidth: 1,
                        borderRadius: 4,
                        paddingHorizontal: 7,
                        textMarginHorizontal: 0,
                        textFontSize: 14,
                        textFontWeight: 'bold',
                        iconWidth: 18,
                        iconHeight: 18,
                        iconMargin: 4,
                    },
                    md: {
                        minWidth: 32,
                        minHeight: 32,
                        borderWidth: 1,
                        borderRadius: 6,
                        paddingHorizontal: 11,
                        textMarginHorizontal: 0,
                        textFontSize: 15,
                        textFontWeight: 'bold',
                        iconWidth: 24,
                        iconHeight: 24,
                        iconMargin: 8,
                    },
                    lg: {
                        minWidth: 40,
                        minHeight: 40,
                        borderWidth: 1,
                        borderRadius: 6,
                        paddingHorizontal: 15,
                        textMarginHorizontal: 0,
                        textFontSize: 15,
                        textFontWeight: 'bold',
                        iconWidth: 24,
                        iconHeight: 24,
                        iconMargin: 8,
                    },
                    xl: {
                        minWidth: 44,
                        minHeight: 44,
                        borderWidth: 1,
                        borderRadius: 8,
                        paddingHorizontal: 15,
                        textMarginHorizontal: 0,
                        textFontSize: 18,
                        textFontWeight: 'bold',
                        iconWidth: 28,
                        iconHeight: 28,
                        iconMargin: 8,
                    },
                },
            },
        },
        outline: {
            mapping: {},
            variantGroups: {
                status: {
                    primary: {
                        borderColor: '$color-ui2-brand-600',
                        borderColorDark: '$color-ui2-brand-500',
                        textColor: '$color-ui2-brand-600',
                        textColorDark: '$color-ui2-brand-500',
                        iconTintColor: '$color-ui2-brand-600',
                        iconTintColorDark: '$color-ui2-brand-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-brand-600',
                                borderColorDark: '$color-ui2-brand-500',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-brand-600',
                                backgroundColorDark: '$color-ui2-brand-500',
                            },
                            active: {
                                borderColor: '$color-ui2-brand-800',
                                borderColorDark: '$color-ui2-brand-700',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-brand-800',
                                backgroundColorDark: '$color-ui2-brand-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-brand-800',
                                borderColorDark: '$color-ui2-brand-700',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-brand-800',
                                backgroundColorDark: '$color-ui2-brand-700',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    secondary: {
                        borderColor: '$color-ui2-neutral-300',
                        borderColorDark: '$color-ui2-neutral-700',
                        textColor: '$color-ui2-neutral-900',
                        textColorDark: '$color-white',
                        iconTintColor: '$color-ui2-neutral-900',
                        iconTintColorDark: '$color-white',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-900',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-ui2-neutral-900',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-ui2-neutral-700',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-500',
                                textColor: '$color-ui2-neutral-900',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-ui2-neutral-900',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-neutral-300',
                                backgroundColorDark: '$color-ui2-neutral-500',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-500',
                                textColor: '$color-ui2-neutral-900',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-ui2-neutral-900',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-neutral-300',
                                backgroundColorDark: '$color-ui2-neutral-500',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    subtle: {
                        borderColor: '$color-ui2-neutral-300',
                        borderColorDark: '$color-white',
                        textColor: '$color-ui2-neutral-400',
                        textColorDark: '$color-white',
                        iconTintColor: '$color-ui2-neutral-400',
                        iconTintColorDark: '$color-white',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-white',
                                textColor: '$color-ui2-neutral-400',
                                textColorDark: '$color-ui2-neutral-800',
                                iconTintColor: '$color-ui2-neutral-400',
                                iconTintColorDark: '$color-ui2-neutral-800',
                                backgroundColor: '$color-ui2-neutral-50',
                                backgroundColorDark: '$color-white',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-white',
                                textColor: '$color-ui2-neutral-400',
                                textColorDark: '$color-ui2-neutral-800',
                                iconTintColor: '$color-ui2-neutral-400',
                                iconTintColorDark: '$color-ui2-neutral-800',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-white-transparent-80',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-white',
                                textColor: '$color-ui2-neutral-400',
                                textColorDark: '$color-ui2-neutral-800',
                                iconTintColor: '$color-ui2-neutral-400',
                                iconTintColorDark: '$color-ui2-neutral-800',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-white-transparent-80',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    success: {
                        borderColor: '$color-ui2-success-500',
                        borderColorDark: '$color-ui2-success-500',
                        textColor: '$color-ui2-success-500',
                        textColorDark: '$color-ui2-success-500',
                        iconTintColor: '$color-ui2-success-500',
                        iconTintColorDark: '$color-ui2-success-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-success-500',
                                borderColorDark: '$color-ui2-success-500',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-success-500',
                                backgroundColorDark: '$color-ui2-success-500',
                            },
                            active: {
                                borderColor: '$color-ui2-success-700',
                                borderColorDark: '$color-ui2-success-700',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-success-700',
                                backgroundColorDark: '$color-ui2-success-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-success-700',
                                borderColorDark: '$color-ui2-success-700',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-success-700',
                                backgroundColorDark: '$color-ui2-success-700',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    warning: {
                        borderColor: '$color-ui2-warning-500',
                        borderColorDark: '$color-ui2-warning-500',
                        textColor: '$color-ui2-warning-500',
                        textColorDark: '$color-ui2-warning-500',
                        iconTintColor: '$color-ui2-warning-500',
                        iconTintColorDark: '$color-ui2-warning-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-warning-500',
                                borderColorDark: '$color-ui2-warning-500',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-warning-500',
                                backgroundColorDark: '$color-ui2-warning-500',
                            },
                            active: {
                                borderColor: '$color-ui2-warning-700',
                                borderColorDark: '$color-ui2-warning-700',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-warning-700',
                                backgroundColorDark: '$color-ui2-warning-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-warning-700',
                                borderColorDark: '$color-ui2-warning-700',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-warning-700',
                                backgroundColorDark: '$color-ui2-warning-700',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    danger: {
                        borderColor: '$color-ui2-danger-500',
                        borderColorDark: '$color-ui2-danger-500',
                        textColor: '$color-ui2-danger-500',
                        textColorDark: '$color-ui2-danger-500',
                        iconTintColor: '$color-ui2-danger-500',
                        iconTintColorDark: '$color-ui2-danger-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-danger-500',
                                borderColorDark: '$color-ui2-danger-500',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-danger-500',
                                backgroundColorDark: '$color-ui2-danger-500',
                            },
                            active: {
                                borderColor: '$color-ui2-danger-700',
                                borderColorDark: '$color-ui2-danger-700',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-danger-700',
                                backgroundColorDark: '$color-ui2-danger-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-danger-700',
                                borderColorDark: '$color-ui2-danger-700',
                                textColor: '$color-white',
                                textColorDark: '$color-white',
                                iconTintColor: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-danger-700',
                                backgroundColorDark: '$color-ui2-danger-700',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-300',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    transparent: {
                        borderColor: '$color-ui2-neutral-transparent-64',
                        borderColorDark: '$color-ui2-neutral-transparent-64',
                        textColor: '$color-ui2-neutral-900',
                        textColorDark: '$color-ui2-neutral-900',
                        iconTintColor: '$color-ui2-neutral-900',
                        iconTintColorDark: '$color-ui2-neutral-900',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-transparent-64',
                                borderColorDark: '$color-ui2-neutral-transparent-64',
                                textColor: '$color-ui2-neutral-900',
                                textColorDark: '$color-ui2-neutral-900',
                                iconTintColor: '$color-ui2-neutral-900',
                                iconTintColorDark: '$color-ui2-neutral-900',
                                backgroundColor: '$color-ui2-neutral-transparent-16',
                                backgroundColorDark: '$color-ui2-neutral-transparent-16',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-transparent-64',
                                borderColorDark: '$color-ui2-neutral-transparent-64',
                                textColor: '$color-ui2-neutral-900',
                                textColorDark: '$color-ui2-neutral-900',
                                iconTintColor: '$color-ui2-neutral-900',
                                iconTintColorDark: '$color-ui2-neutral-900',
                                backgroundColor: '$color-ui2-neutral-transparent-24',
                                backgroundColorDark: '$color-ui2-neutral-transparent-24',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-transparent-64',
                                borderColorDark: '$color-ui2-neutral-transparent-64',
                                textColor: '$color-ui2-neutral-900',
                                textColorDark: '$color-ui2-neutral-900',
                                iconTintColor: '$color-ui2-neutral-900',
                                iconTintColorDark: '$color-ui2-neutral-900',
                                backgroundColor: '$color-ui2-neutral-transparent-24',
                                backgroundColorDark: '$color-ui2-neutral-transparent-24',
                            },
                            disabled: {
                                borderColor: '$color-ui2-neutral-transparent-64',
                                borderColorDark: '$color-ui2-neutral-transparent-64',
                                textColor: '$color-ui2-neutral-400',
                                textColorDark: '$color-ui2-neutral-400',
                                iconTintColor: '$color-ui2-neutral-400',
                                iconTintColorDark: '$color-ui2-neutral-400',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    tertiary: {
                        borderColor: '$color-gray-200',
                        borderColorDark: '$color-gray-200',
                        textColor: '$color-text-primary',
                        textColorDark: '$color-text-primary',
                        iconTintColor: '$color-text-primary',
                        iconTintColorDark: '$color-text-primary',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-gray-200',
                                borderColorDark: '$color-gray-200',
                                textColor: '$color-text-primary',
                                textColorDark: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                iconTintColorDark: '$color-text-primary',
                                backgroundColor: '$color-gray-50',
                                backgroundColorDark: '$color-gray-transparent-40',
                            },
                            active: {
                                borderColor: '$color-gray-200',
                                borderColorDark: '$color-gray-200',
                                textColor: '$color-text-primary',
                                textColorDark: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                iconTintColorDark: '$color-text-primary',
                                backgroundColor: '$color-gray-100',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-gray-200',
                                borderColorDark: '$color-gray-200',
                                textColor: '$color-text-primary',
                                textColorDark: '$color-text-primary',
                                iconTintColor: '$color-text-primary',
                                iconTintColorDark: '$color-text-primary',
                                backgroundColor: '$color-gray-100',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            disabled: {
                                borderColor: '$color-gray-100',
                                borderColorDark: '$color-gray-100',
                                textColor: '$color-gray-100',
                                textColorDark: '$color-gray-100',
                                iconTintColor: '$color-gray-100',
                                iconTintColorDark: '$color-gray-100',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                },
            },
        },
        ghost: {
            mapping: {},
            variantGroups: {
                status: {
                    primary: {
                        borderColor: 'transparent',
                        borderColorDark: 'transparent',
                        textColor: '$color-ui2-brand-600',
                        textColorDark: '$color-ui2-brand-500',
                        iconTintColor: '$color-ui2-brand-600',
                        iconTintColorDark: '$color-ui2-brand-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-brand-100',
                                borderColorDark: '$color-ui2-brand-500',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-brand-100',
                                backgroundColorDark: '$color-ui2-brand-500',
                            },
                            active: {
                                borderColor: '$color-ui2-brand-200',
                                borderColorDark: '$color-ui2-brand-700',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-brand-200',
                                backgroundColorDark: '$color-ui2-brand-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-brand-200',
                                borderColorDark: '$color-ui2-brand-700',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-brand-200',
                                backgroundColorDark: '$color-ui2-brand-700',
                            },
                            disabled: {
                                borderColor: 'transparent',
                                borderColorDark: 'transparent',
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    secondary: {
                        borderColor: 'transparent',
                        borderColorDark: 'transparent',
                        textColor: '$color-ui2-neutral-900',
                        textColorDark: '$color-white',
                        iconTintColor: '$color-ui2-neutral-900',
                        iconTintColorDark: '$color-white',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: '$color-ui2-neutral-700',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-ui2-neutral-700',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: '$color-ui2-neutral-500',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-ui2-neutral-500',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: '$color-ui2-neutral-500',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-ui2-neutral-500',
                            },
                            disabled: {
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                borderColor: 'transparent',
                                borderColorDark: 'transparent',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    subtle: {
                        borderColor: 'transparent',
                        borderColorDark: 'transparent',
                        textColor: '$color-ui2-neutral-400',
                        textColorDark: '$color-white',
                        iconTintColor: '$color-ui2-neutral-400',
                        iconTintColorDark: '$color-white',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: '$color-white',
                                backgroundColor: '$color-ui2-neutral-100',
                                textColorDark: '$color-ui2-neutral-800',
                                iconTintColorDark: '$color-ui2-neutral-800',
                                backgroundColorDark: '$color-white',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: '$color-white-transparent-80',
                                backgroundColor: '$color-ui2-neutral-200',
                                textColorDark: '$color-ui2-neutral-800',
                                iconTintColorDark: '$color-ui2-neutral-800',
                                backgroundColorDark: '$color-white-transparent-80',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: '$color-white-transparent-80',
                                backgroundColor: '$color-ui2-neutral-200',
                                textColorDark: '$color-ui2-neutral-800',
                                iconTintColorDark: '$color-ui2-neutral-800',
                                backgroundColorDark: '$color-white-transparent-80',
                            },
                            disabled: {
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                borderColor: 'transparent',
                                borderColorDark: 'transparent',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    success: {
                        borderColor: 'transparent',
                        borderColorDark: 'transparent',
                        textColor: '$color-ui2-success-500',
                        textColorDark: '$color-ui2-success-500',
                        iconTintColor: '$color-ui2-success-500',
                        iconTintColorDark: '$color-ui2-success-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-success-100',
                                borderColorDark: '$color-ui2-success-500',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-success-100',
                                backgroundColorDark: '$color-ui2-success-500',
                            },
                            active: {
                                borderColor: '$color-ui2-success-200',
                                borderColorDark: '$color-ui2-success-700',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-success-200',
                                backgroundColorDark: '$color-ui2-success-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-success-200',
                                borderColorDark: '$color-ui2-success-700',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-success-200',
                                backgroundColorDark: '$color-ui2-success-700',
                            },
                            disabled: {
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                borderColor: 'transparent',
                                borderColorDark: 'transparent',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    warning: {
                        borderColor: 'transparent',
                        borderColorDark: 'transparent',
                        textColor: '$color-ui2-warning-500',
                        textColorDark: '$color-ui2-warning-500',
                        iconTintColor: '$color-ui2-warning-500',
                        iconTintColorDark: '$color-ui2-warning-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-warning-100',
                                borderColorDark: '$color-ui2-warning-500',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-warning-100',
                                backgroundColorDark: '$color-ui2-warning-500',
                            },
                            active: {
                                borderColor: '$color-ui2-warning-200',
                                borderColorDark: '$color-ui2-warning-700',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-warning-200',
                                backgroundColorDark: '$color-ui2-warning-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-warning-200',
                                borderColorDark: '$color-ui2-warning-700',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-warning-200',
                                backgroundColorDark: '$color-ui2-warning-700',
                            },
                            disabled: {
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                borderColor: 'transparent',
                                borderColorDark: 'transparent',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    danger: {
                        borderColor: 'transparent',
                        borderColorDark: 'transparent',
                        textColor: '$color-ui2-danger-500',
                        textColorDark: '$color-ui2-danger-500',
                        iconTintColor: '$color-ui2-danger-500',
                        iconTintColorDark: '$color-ui2-danger-500',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-danger-100',
                                borderColorDark: '$color-ui2-danger-500',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-danger-100',
                                backgroundColorDark: '$color-ui2-danger-500',
                            },
                            active: {
                                borderColor: '$color-ui2-danger-200',
                                borderColorDark: '$color-ui2-danger-700',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-danger-200',
                                backgroundColorDark: '$color-ui2-danger-700',
                            },
                            focus: {
                                borderColor: '$color-ui2-danger-200',
                                borderColorDark: '$color-ui2-danger-700',
                                textColorDark: '$color-white',
                                iconTintColorDark: '$color-white',
                                backgroundColor: '$color-ui2-danger-200',
                                backgroundColorDark: '$color-ui2-danger-700',
                            },
                            disabled: {
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                borderColor: 'transparent',
                                borderColorDark: 'transparent',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    transparent: {
                        borderColor: 'transparent',
                        borderColorDark: 'transparent',
                        textColor: '$color-ui2-neutral-900',
                        textColorDark: '$color-ui2-neutral-900',
                        iconTintColor: '$color-ui2-neutral-900',
                        iconTintColorDark: '$color-ui2-neutral-900',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: 'transparent',
                                textColorDark: '$color-ui2-neutral-900',
                                iconTintColorDark: '$color-ui2-neutral-900',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-ui2-neutral-transparent-16',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: 'transparent',
                                textColorDark: '$color-ui2-neutral-900',
                                iconTintColorDark: '$color-ui2-neutral-900',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-ui2-neutral-transparent-24',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: 'transparent',
                                textColorDark: '$color-ui2-neutral-900',
                                iconTintColorDark: '$color-ui2-neutral-900',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-ui2-neutral-transparent-24',
                            },
                            disabled: {
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                borderColor: 'transparent',
                                borderColorDark: 'transparent',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                    tertiary: {
                        borderColor: 'transparent',
                        borderColorDark: 'transparent',
                        textColor: '$color-text-primary',
                        textColorDark: '$color-text-primary',
                        iconTintColor: '$color-text-primary',
                        iconTintColorDark: '$color-text-primary',
                        backgroundColor: 'transparent',
                        backgroundColorDark: 'transparent',
                        state: {
                            hover: {
                                borderColor: '$color-ui2-neutral-100',
                                borderColorDark: '$color-gray-transparent-40',
                                textColorDark: '$color-text-primary',
                                iconTintColorDark: '$color-text-primary',
                                backgroundColor: '$color-ui2-neutral-100',
                                backgroundColorDark: '$color-gray-transparent-40',
                            },
                            active: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: '$color-gray-transparent-56',
                                textColorDark: '$color-text-primary',
                                iconTintColorDark: '$color-text-primary',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            focus: {
                                borderColor: '$color-ui2-neutral-200',
                                borderColorDark: '$color-gray-transparent-56',
                                textColorDark: '$color-text-primary',
                                iconTintColorDark: '$color-text-primary',
                                backgroundColor: '$color-ui2-neutral-200',
                                backgroundColorDark: '$color-gray-transparent-56',
                            },
                            disabled: {
                                textColor: '$color-ui2-neutral-300',
                                textColorDark: '$color-ui2-neutral-700',
                                iconTintColor: '$color-ui2-neutral-300',
                                iconTintColorDark: '$color-ui2-neutral-700',
                                borderColor: 'transparent',
                                borderColorDark: 'transparent',
                                backgroundColor: 'transparent',
                                backgroundColorDark: 'transparent',
                            },
                        },
                    },
                },
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNAButton.theme.alucio.js.map